import React, {useCallback} from 'react';

import {Column} from './../../common/Layouts/Layouts';
import {TabsRnrDiv, ContentTabUl, TAImage} from './TaRnr.styles';
import TripAdvisor from '../TripAdvisor/TripAdvisor';
import RnR from '../RnR/RnR';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {selectedRnRType} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';
import {updateSelectedRnrType} from '@stencil/hotels-ugc-redux/src/hotels-ugc-actions';

const TaRnr = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector(selectedRnRType, shallowEqual);

  const updateSelectedTab = useCallback(
    name => {
      return dispatch(updateSelectedRnrType(name));
    },
    [dispatch],
  );
  const onSelectingTab = name => {
    updateSelectedTab(name);
  };

  return (
    <>
      <Column>
        <TabsRnrDiv>
          <ContentTabUl>
            <li
              className={selectedTab === 'ta' ? 'active' : ''}
              onClick={() => onSelectingTab('ta')}
            >
              <TAImage src={'https://gos3.ibcdn.com/taLogo-1578997688.png'} alt="Segment Image" />
              Tripadvisor reviews
            </li>
            <li
              onClick={() => onSelectingTab('gi')}
              className={selectedTab === 'gi' ? 'active' : ''}
            >
              <TAImage
                src={'https://gos3.ibcdn.com/goibibo_logo_hotel-1580450475.png'}
                style={{width: '40px'}}
                alt="Segment Image"
              />
              Indian traveller reviews
            </li>
          </ContentTabUl>
        </TabsRnrDiv>
      </Column>
      {selectedTab === 'ta' && <TripAdvisor />}
      {selectedTab === 'gi' && <RnR />}
    </>
  );
};

export default TaRnr;
